import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import useResolveDisputesCard from './useResolveDisputesCard';
import { Heading, Text, Flex, Strong, Select } from '@scale/scaleui-radix';
import { DisputeDecision } from '@scale/shared/types/chat/disputes';
import MultiSelect from 'corp/components/UI/Select';
import { twMerge } from 'tailwind-merge';
import { compassErrorClassName } from 'react-scale/corp/views/DataCompassCardsV2/utils';

const ResolveDisputesCardComponent: CompassCardComponent = ({
  index,
}: CompassCardComponentProps) => {
  const {
    resolution,
    setResolution,
    selectedDisputeColumn,
    setSelectedDisputeColumn,
    columns,
    hasError,
  } = useResolveDisputesCard(index);

  const resolutionOptions = [
    { value: DisputeDecision.ACCEPTED, label: 'Approve' },
    { value: DisputeDecision.SCORE_INVALIDATED, label: 'Invalidate Score' },
    { value: DisputeDecision.REJECTED, label: 'Reject' },
  ];

  return (
    <Flex direction="column" gap="4">
      <Heading size="3">
        <Strong>Resolve Dispute</Strong>
      </Heading>
      <Text size="2">
        Resolve disputes by selecting the resolution decision and dispute column.
      </Text>

      <Flex direction="column" gap="4" width="full">
        <Flex direction="column" gap="2">
          <Text>Dispute Column</Text>
          <MultiSelect
            className={twMerge(
              'w-60 rounded-lg',
              hasError && !selectedDisputeColumn && compassErrorClassName,
            )}
            label="Select column"
            multi={false}
            options={columns.map(column => ({
              value: column.id ?? '-',
              label: column.header ?? '-',
            }))}
            disabled={false}
            placeholder={`Select a column with the disputes assignment id...`}
            isSearchable={true}
            isClearable={true}
            value={selectedDisputeColumn}
            onChange={(e: any) => {
              setSelectedDisputeColumn(e === null ? null : e.value);
            }}
          />
        </Flex>

        <Flex direction="column" gap="2">
          <Text>Resolution*</Text>
          <Select.Root
            value={resolution || ''}
            onValueChange={value => {
              setResolution((value as DisputeDecision) || DisputeDecision.ACCEPTED);
            }}
          >
            <Select.Trigger className="w-60 rounded-lg" placeholder="Select resolution" />
            <Select.Content position="popper">
              {resolutionOptions.map(option => (
                <Select.Item key={option.value} value={option.value}>
                  {option.label}
                </Select.Item>
              ))}
            </Select.Content>
          </Select.Root>
          {hasError && !resolution && (
            <Text className="text-danger-500 w-60 pt-1">Please select a resolution</Text>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default ResolveDisputesCardComponent;
